export class Content {
    public static Go_to_page_label = "Go to page";
    public static First_button = "First";
    public static Previous_button = "Previous";
    public static Records_per_page_label = "Records per page";
    public static Next_button = "Next";
    public static Last_button = "Last";
    public static Page = "page";

    public static Year = "Year";
    public static Label_day = "Select day";
    public static Label_year = "Select year";
    public static Day = "Day";
    public static Close = "close";
    public static Value_must_be_a_number = "Value must be a number";
    public static Value_must_be_a_valid_date = "Value must be a valid date";
    public static Label_month = "Select month";
    public static Loading = "loading";
    public static Month = "Month";
}
